import { Component, Input, OnInit } from '@angular/core';
import { PlayerDetailsViewModel } from '../../../shared/models/player.model';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'app-player-header',
    imports: [CommonModule, MatIconModule, MatDividerModule, TranslatePipe
    ],
    templateUrl: './player-header.component.html',
    styleUrls: ['./player-header.component.css']
})
export class PlayerHeaderComponent implements OnInit {

  @Input() Player: PlayerDetailsViewModel;
  constructor() { }

  ngOnInit(): void {
  }

}
